module.exports = __webpack_public_path__ + "media/images/front/medical_leaders/hospital_list/img_doctor20-8e00fee3e8d794db5af992e070b20dd4.png";